(() => {
  if (window.AniverseCartPicksLoaded) return;
  window.AniverseCartPicksLoaded = true;

  const HISTORY_KEY = 'aniverse_cart_picks_history';

  function shuffle(array) {
    const result = [...array];

    for (let i = result.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }

    return result;
  }

  function historyGet() {
    try {
      const history = JSON.parse(
        sessionStorage.getItem(HISTORY_KEY) || '[]'
      );

      return Array.isArray(history) ? history : [];
    } catch {
      return [];
    }
  }

  function historySave(ids) {
    try {
      sessionStorage.setItem(
        HISTORY_KEY,
        JSON.stringify(ids.slice(-40))
      );
    } catch {}
  }

  function getSources(block) {
    return [
      ...block.querySelectorAll('.av-cart-picks__source')
    ];
  }

  function chooseProducts(block) {
    const all = getSources(block);

    if (!all.length) return [];

    const history = historyGet();
    const historySet = new Set(history.map(String));

    const fresh = shuffle(
      all.filter(
        item =>
          !historySet.has(
            String(item.dataset.productId)
          )
      )
    );

    const old = shuffle(
      all.filter(
        item =>
          historySet.has(
            String(item.dataset.productId)
          )
      )
    );

    let selected = [...fresh, ...old].slice(0, 3);

    if (fresh.length === 0 && all.length > 3) {
      historySave([]);
      selected = shuffle(all).slice(0, 3);
    }

    historySave([
      ...history,
      ...selected.map(item => item.dataset.productId)
    ]);

    return selected;
  }

  function render(block) {
    if (!block || !block.isConnected) return;

    const list = block.querySelector(
      '.av-cart-picks__list'
    );

    if (!list) return;

    const selected = chooseProducts(block);

    if (!selected.length) {
      list.innerHTML = `
        <div class="av-cart-picks__empty">
          Rohkem soovitusi hetkel pole ✨
        </div>
      `;
      return;
    }

    list.innerHTML = selected
      .map((item, index) => {
        const title = item.dataset.title || '';
        const price = item.dataset.price || '';
        const url = item.dataset.url || '#';
        const image = item.dataset.image || '';
        const variantId = item.dataset.variantId || '';

        const directAdd =
          item.dataset.directAdd === 'true';

        const action = directAdd
          ? `
            <button
              type="button"
              class="av-cart-picks__add"
              data-variant-id="${variantId}"
              data-product-id="${item.dataset.productId || ''}"
            >
              Lisa +
            </button>
          `
          : `
            <a
              href="${url}"
              class="av-cart-picks__choose"
            >
              Vali →
            </a>
          `;

        return `
          <div
            class="av-cart-picks__item"
            style="animation-delay:${index * 45}ms"
          >
            <a
              href="${url}"
              class="av-cart-picks__image-link"
            >
              <img
                src="${image}"
                alt=""
                class="av-cart-picks__image"
                loading="lazy"
              >
            </a>

            <div class="av-cart-picks__info">
              <a
                href="${url}"
                class="av-cart-picks__title"
              >
                ${title}
              </a>

              <div class="av-cart-picks__price">
                ${price}
              </div>
            </div>

            ${action}
          </div>
        `;
      })
      .join('');
  }

  /*
   * Инициализация блока.
   * Проверяем список товаров, чтобы после обновления
   * корзины рекомендации пересобирались заново.
   */
  function initBlock(block, force = false) {
    if (!block) return;

    const signature = getSources(block)
      .map(item => item.dataset.productId)
      .join('|');

    const list = block.querySelector(
      '.av-cart-picks__list'
    );

    const needsRender =
      force ||
      block.dataset.avPoolSignature !== signature ||
      !list ||
      list.children.length === 0;

    if (!needsRender) return;

    block.dataset.avPoolSignature = signature;

    render(block);
  }

  function initAll(force = false) {
    document
      .querySelectorAll('[data-av-cart-picks]')
      .forEach(block => initBlock(block, force));
  }

  /*
   * REFRESH
   */
  document.addEventListener('click', event => {
    const refresh = event.target.closest(
      '.av-cart-picks__refresh'
    );

    if (!refresh) return;

    const block = refresh.closest(
      '[data-av-cart-picks]'
    );

    if (!block) return;

    refresh.style.transform = 'rotate(180deg)';

    render(block);

    setTimeout(() => {
      refresh.style.transform = '';
    }, 220);
  });

  /*
   * ADD TO CART
   */
  document.addEventListener('click', async event => {
    const button = event.target.closest(
      '.av-cart-picks__add'
    );

    if (!button || button.disabled) return;

    const variantId = button.dataset.variantId;
    const productId = button.dataset.productId;

    if (!variantId) return;

    button.disabled = true;
    button.textContent = '...';

    try {
      if (
        !window.Shopify ||
        !window.Shopify.actions ||
        !window.Shopify.actions.updateCart
      ) {
        throw new Error(
          'Shopify cart action is not available'
        );
      }

      const result =
        await window.Shopify.actions.updateCart(
          {
            lines: [
              {
                merchandiseId: String(variantId),
                quantity: 1
              }
            ]
          },
          {
            context: 'cart'
          }
        );

      if (
        result?.userErrors &&
        result.userErrors.length
      ) {
        throw new Error(
          result.userErrors[0].message
        );
      }

      button.textContent = 'Lisatud ✓';
      button.classList.add('is-added');

      const block = button.closest(
        '[data-av-cart-picks]'
      );

      if (block) {
        block
          .querySelectorAll(
            '.av-cart-picks__source'
          )
          .forEach(source => {
            if (
              String(source.dataset.productId) ===
              String(productId)
            ) {
              source.remove();
            }
          });

        setTimeout(() => {
          if (block.isConnected) {
            initBlock(block, true);
          }
        }, 300);
      }
    } catch (error) {
      console.error(
        'AniVerse cart upsell:',
        error
      );

      button.disabled = false;
      button.textContent = 'Lisa +';
    }
  });

  /*
   * Horizon динамически заменяет корзину.
   * Следим именно за новыми/обновлёнными блоками.
   */
  let updateTimer = null;

  const observer = new MutationObserver(mutations => {
    let cartChanged = false;

    for (const mutation of mutations) {
      const target =
        mutation.target instanceof Element
          ? mutation.target
          : mutation.target.parentElement;

      /*
       * Изменения, которые мы сами делаем
       * внутри списка рекомендаций, игнорируем.
       */
      if (
        target?.closest('.av-cart-picks__list')
      ) {
        continue;
      }

      if (
        target?.closest('[data-av-cart-picks]') ||
        [...mutation.addedNodes].some(node => {
          if (!(node instanceof Element)) {
            return false;
          }

          return (
            node.matches?.('[data-av-cart-picks]') ||
            node.querySelector?.(
              '[data-av-cart-picks]'
            )
          );
        })
      ) {
        cartChanged = true;
      }
    }

    if (!cartChanged) return;

    clearTimeout(updateTimer);

    updateTimer = setTimeout(() => {
      initAll();
    }, 80);
  });

  function start() {
    initAll(true);

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();